import { atom, selector } from "recoil";
import { COUNTDOWN_TIME } from "./config";

export const refreshTime = atom({
  key: "refreshTime",
  default: COUNTDOWN_TIME,
});

export const refreshUpdateTime = atom({
  key: "refreshUpdateTime",
  default: null,
});

export const remainingTime = atom({
  key: "remainingType",
  default: COUNTDOWN_TIME,
});

export const isPause = atom({
  key: "interval",
  default: false,
});

export const countdownTime = selector({
  key: "countdownTime",
  get: () => COUNTDOWN_TIME,
});

export const backgroundColor = atom({
  key: "backgroundColor",
  default: "",
});

export const data = atom({
  key: "data",
  default: {
    word: null,
    partOfSpeech: null,
    definition: null,
  },
});
